import React, { useEffect } from "react";
import PropTypes from "prop-types";

import styles from "./ErrorBox.module.css";
import DisappointedIcon from "src/assets/icons/disappointed.svg";
import Button from "src/app/components/ContentElements/Button/Button";

const ErrorBox = ({
  showHomepagebutton = false,
  header,
  description,
  buttonData = {},
  errorType,
  status,
}) => {
  useEffect(() => {
    window.s.prop52 = `${errorType}|${status}|${description}`;
  });

  return (
    <div className={styles.errorBox}>
      <DisappointedIcon className={styles.icon} />
      <h1 className={styles.header}>{header}</h1>
      <p className={styles.text}>{description}</p>
      {showHomepagebutton && (
        <div className={styles.buttonContainer}>
          <Button data={buttonData} size="large" style="black" />
        </div>
      )}
    </div>
  );
};

export default ErrorBox;

ErrorBox.propTypes = {
  header: PropTypes.string,
  description: PropTypes.string,
  showHomepagebutton: PropTypes.bool,
  status: PropTypes.number,
  errorType: PropTypes.string,
  buttonData: PropTypes.object,
};
